import AppLog from './AppLog';

export default AppLog;